import { apiSlice } from "./apiSlice";

const projectPermissionSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProjectPermission: builder.query({
            query: (projectId) => ({
                url: `RolePermission/project/${projectId}`,
                // params: req,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),
    }),
});

export const {
    useGetProjectPermissionQuery,
    useLazyGetProjectPermissionQuery
} = projectPermissionSlice;
